// 吊装申请
import Request from '../util/request';

// const path = "http://10.123.111.158:8647/thd_dzzysq"
const path = "/eip-mapp-oa-server/thd_dzzysq"

// 获取吊装申请列表
export function queryTask(data) {
 return Request({
  url: path + '/queryTask',
  method: 'post',
  data
 })
}

export function getUsers(data) {
 return Request({
  url: '/eip-mapp-oa-server/approver_user/getUsers',
  method: 'post',
  data
 })
}

export function pageQuery(data) {
 return Request({
  url: path + '/pageQuery',
  method: 'post',
  data
 })
}

// 任务汇总
export function queryTotalData(data) {
 return Request({
  url: path + '/queryTotalData',
  method: 'post',
  data
 })
}

// 明细列表
export function detailPageData(data) {
 return Request({
  url: path + '/detailPageData',
  method: 'post',
  data
 })
}